import React, { useState, useEffect } from 'react'

// components
import AppCard from 'src/components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'
import RefundList from './RefundList'

// helpers
import { columnBookingList } from 'src/components/table-column/TableColumnList'
import {
  formUrlQuery,
  formSortQuery,
  formBookingListFilterQuery
} from 'src/helpers/format-queries'
import Axios from 'src/helpers/axios'

const BookingList = () => {

  const [bookingList, setBookingList] = useState([]);
  const [bookingListCount, setBookingListCount] = useState(0);
  const [bookingListPerPage, setBookingListPerPage] = useState(10);
  const [activeBookingListPage, setActiveBookingListPage] = useState(1);
  const [searchBookingListFilter, setSearchBookingListFilter] = useState("");
  const [columnBookingListSorter, setColumnBookingListSorter] = useState({ column: "id", state: "desc" });

  const [showConfirmCancel, setShowConfirmCancel] = useState({ show: false, item: {} })
  const [cancelReason, setCancelReason] = useState('')

  const [servicePackageList, setServicePackageList] = useState([])
  const [paymentMethodList, setPaymentMethodList] = useState([])

  // column filter for created on
  const [startCreatedDate, setStartCreatedDate] = useState('')
  const [endCreatedDate, setEndCreatedDate] = useState('')

  // column filter for booking date
  const [startBookingDate, setStartBookingDate] = useState('')
  const [endBookingDate, setEndBookingDate] = useState('')

  // column filter for booking status
  const [filterBookingStatus, setFilterBookingStatus] = useState('')

  // column filter for booking amount
  const [filterBookingAmount, setFilterBookingAmount] = useState('')

  // column filter for payment method
  const [filterPaymentMethod, setFilterPaymentMethod] = useState('')

  // column filter for service package
  const [filterServicePackage, setFilterServicePackage] = useState('')

  useEffect(() => {
    let filterObj = {
      booking_status: filterBookingStatus,
      package_id: filterServicePackage,
      payment_method_id: filterPaymentMethod,
      booking_amount: filterBookingAmount,
      start_created_date: startCreatedDate,
      end_created_date: endCreatedDate,
      start_booking_date: startBookingDate,
      end_booking_date: endBookingDate
    }
    let queries = {
      search: searchBookingListFilter,
      limit: bookingListPerPage,
      offset: bookingListPerPage * activeBookingListPage - bookingListPerPage,
      sort: formSortQuery(columnBookingListSorter),
    };
    let filterQueries = formBookingListFilterQuery(filterObj)
    if (Object.keys(filterQueries).length !== 0) {
      queries = {
        ...queries,
        ...filterQueries
      }
    }
    queries = formUrlQuery(queries);
    fetchAllBookings(queries);
  }, [
    searchBookingListFilter,
    bookingListPerPage,
    activeBookingListPage,
    columnBookingListSorter,
    filterBookingStatus,
    filterServicePackage,
    filterPaymentMethod,
    filterBookingAmount,
    startCreatedDate,
    endCreatedDate,
    startBookingDate,
    endBookingDate
  ]);

  useEffect(() => {
    fetchAllServicePackage();
    fetchAllPaymentMethod();
  }, []);

  const fetchAllBookings = (queries) => {
    Axios({
      method: "get",
      url: `/api/booking/v1/bookings/all?${queries}`,
    })
      .then(({ data }) => {
        const result = data && data.result
        const count = data && data.count
        const tempBookingList = result.map((d) => ({
          ...d,
          customer_name: d?.guests && d?.guests?.length > 0 ? `${d?.guests[0].first_name} ${d?.guests[0].last_name}` : '-',
          service_variant: d?.package && d?.package?.title && d?.package?.title && d?.package?.service && d?.package?.service?.title ? `${d?.package?.service?.title} (${d?.package?.title})` : '-',
          booking_date: d?.booking_time && d?.booking_time?.date,
          booking_amount: d?.transaction_details && d?.transaction_details?.length > 0 ? d?.transaction_details[0]?.transaction_amount : '-',
          payment_method: d?.transaction_details && d?.transaction_details?.length > 0 ? d?.transaction_details[0]?.payment_channel?.name : '-'
        }));

        setBookingList(tempBookingList);
        setBookingListCount(count)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchAllServicePackage = () => {
    Axios({
      method: "get",
      url: `/api/booking/v1/services/package/all`,
    })
      .then(({ data }) => {
        setServicePackageList(data)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchAllPaymentMethod = () => {
    Axios({
      method: "get",
      url: `/api/booking/v1/mpaymentchannels/all`,
    })
      .then(({ data }) => {
        setPaymentMethodList(data)
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleCancelConfirmation = (item, cancelReason) => {
    Axios({
      method: "post",
      url: `/api/booking/v1/bookings/update/${item.id}`,
      data: {
        status: "cancelled",
        cancel_reason: cancelReason
      }
    })
      .then(({ data }) => {
        setShowConfirmCancel({ show: false, item: {} })
        window.location.reload()
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <>
      {showConfirmCancel.show && (
        <AppModalConfirmation
          confirmationType='cancel-item'
          itemName='booking'
          showModal={showConfirmCancel}
          itemDetails={showConfirmCancel.item}
          setShowModal={setShowConfirmCancel}
          handleConfirmation={handleCancelConfirmation}
          values={cancelReason}
          handleChange={setCancelReason}
        />
      )}
      <AppCard
        className='mb-4'
        headerTitle={<h4>Booking List</h4>}
        bodyContent={
          <AppTable
            bookingListPage
            tableFilter={{ external: true }}
            columnFilter
            setShowConfirmCancel={setShowConfirmCancel}
            tableColumns={
              columnBookingList(
                startCreatedDate,
                endCreatedDate,
                startBookingDate,
                endBookingDate,
                filterBookingStatus,
                filterBookingAmount,
                filterPaymentMethod,
                filterServicePackage,
                setStartCreatedDate,
                setEndCreatedDate,
                setStartBookingDate,
                setEndBookingDate,
                setFilterBookingStatus,
                setFilterBookingAmount,
                setFilterPaymentMethod,
                setFilterServicePackage,
                setActiveBookingListPage,
                servicePackageList,
                paymentMethodList
              )
            }
            tableContent={bookingList}
            contentPerPage={bookingListPerPage}
            activeContentPage={activeBookingListPage}
            contentCount={bookingListCount}
            searchContentFilter={searchBookingListFilter}
            setActiveContentPage={setActiveBookingListPage}
            setSearchContentFilter={setSearchBookingListFilter}
            setContentPerPage={setBookingListPerPage}
            setColumnContentSorter={setColumnBookingListSorter}
            startDateColumnFilter={startCreatedDate}
            endDateColumnFilter={endCreatedDate}
            startBookingDateColumnFilter={startBookingDate}
            endBookingDateColumnFilter={endBookingDate}
          />
        }
      />
      <RefundList />
    </>
  )
}

export default BookingList
